import { State } from "country-state-city";
export const certificationOptions = [
  { value: "all", label: "All Certificates" },
  { value: "organic", label: "Organic" },
  { value: "fair-trade", label: "Fair Trade" },
  { value: "non-gmo", label: "Non-GMO" },
  { value: "sgs", label: "SGS" },
];

export const countryOptions = [
  { value: "all", label: "All Countries" },
  { value: "NG", label: "Nigeria" },
  { value: "GH", label: "Ghana" },
  { value: "KE", label: "Kenya" },
];

export const stateOptions = (country: string) => {
  const states = State.getStatesOfCountry(country || "nigeria");
  return [
    { value: "all", label: "All State/Regions" },
    ...states.map((state) => ({
      value: state.isoCode,
      label: state.name,
    })),
  ];
};

export const sortOptions = [
  { value: "recent", label: "Most Recent" },
  { value: "price-low", label: "Price: Low to High" },
  { value: "price-high", label: "Price: High to Low" },
  { value: "rating-low", label: "Rating: Low to High" },
  { value: "rating-high", label: "Rating: High to Low" },
];
